import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            {contactData.subtitle}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mx-auto mb-4">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-sm mb-1">发送邮件</h3>
              <p className="text-foreground-400 text-xs break-all">{contactData.email}</p>
            </div>

            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mx-auto mb-4">
                <i className="ri-chat-smile-2-line text-accent-600 text-xl"></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-sm mb-1">在线反馈</h3>
              <p className="text-foreground-400 text-xs">填写表单快速沟通</p>
            </div>

            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 mx-auto mb-4">
                <i className="ri-share-forward-line text-secondary-600 text-xl"></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-sm mb-1">内容投稿</h3>
              <p className="text-foreground-400 text-xs">分享你的观影推荐</p>
            </div>
          </div>

          <form
            className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70"
            data-readdy-form
            action="https://readdy.ai/api/form/d9mqvacit35ii3jdlkvg"
            method="POST"
            onSubmit={(e) => { e.preventDefault(); }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-foreground-700 text-sm font-medium mb-2" htmlFor="contact-name">
                  你的称呼
                </label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-foreground-900 text-sm focus:outline-none focus:border-primary-300 transition-colors"
                  placeholder="请输入你的名字"
                />
              </div>
              <div>
                <label className="block text-foreground-700 text-sm font-medium mb-2" htmlFor="contact-email">
                  电子邮箱
                </label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-foreground-900 text-sm focus:outline-none focus:border-primary-300 transition-colors"
                  placeholder="请输入邮箱地址"
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-foreground-700 text-sm font-medium mb-2" htmlFor="contact-message">
                留言内容
              </label>
              <textarea
                id="contact-message"
                name="message"
                rows={4}
                maxLength={500}
                className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-foreground-900 text-sm focus:outline-none focus:border-primary-300 transition-colors resize-none"
                placeholder="请输入你想说的话..."
              ></textarea>
            </div>
            <div className="honeypot-wrapper">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap transition-colors cursor-pointer"
            >
              发送留言
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}